import styled from 'styled-components';

export const SkipLink = styled.a`
  position: fixed;
  top: 8px;
  left: 8px;
  z-index: 10000;
  padding: 8px 16px;
  background: ${(props) => props.theme.colorStyled.ColorWhite};
  color: ${(props) => props.theme.colorStyled.ColorPrimaryBlue};
  border: 2px solid ${(props) => props.theme.colorStyled.ColorPrimaryBlue};
  border-radius: 4px;
  font-family: 'MontserratMedium', sans-serif;
  font-size: 14px;
  font-weight: bold;
  text-decoration: none;
  opacity: 0;
  pointer-events: none;
  &:focus {
    opacity: 1;
    pointer-events: auto;
  }
`;

/* display: contents lets the <main> element exist in the DOM/AOM as the
   semantic landmark + skip-link target while generating no layout box, so
   page-level wrappers (PrimaryWrap, etc.) remain direct flex children of
   PrimaryLayout exactly as they were before this wrapper was introduced. */
export const MainContent = styled.main`
  display: contents;
`;

export const PrimaryLayout = styled.div`
  display: flex;
  background-color: ${(props) => props.theme.colorStyled.ColorBgContent};
  height: 100%;
  &.show-banner {
    margin-top: 50px;
    height: calc(100% - 50px);
  }
`;

/* Zero-sized container with overflow:visible — lets absolutely-positioned
   header children (SkipLink, ExamBanner) render outside normal flow without
   adding any height to the layout above the TopNavBar. */
export const SiteHeader = styled.div`
  width: 0;
  height: 0;
  overflow: visible;
`;
